var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4009_14330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3319 23.5796L11.1743 32.7337L11.1743 32.7337C10.9608 32.9472 10.7915 33.2006 10.6759 33.4796C10.5604 33.7585 10.5009 34.0574 10.5009 34.3593C10.5009 34.6612 10.5604 34.9601 10.6759 35.2391C10.7915 35.518 10.9608 35.7714 11.1743 35.9849C11.3877 36.1983 11.6412 36.3677 11.9201 36.4832C12.199 36.5987 12.4979 36.6582 12.7998 36.6582C13.1017 36.6582 13.4007 36.5987 13.6796 36.4832C13.9585 36.3677 14.2119 36.1983 14.4254 35.9849L14.4255 35.9848L23.5796 26.8272L32.7337 35.9848L32.7337 35.9849C32.9472 36.1983 33.2006 36.3677 33.4796 36.4832C33.7585 36.5987 34.0574 36.6582 34.3593 36.6582C34.6612 36.6582 34.9601 36.5987 35.2391 36.4832C35.518 36.3677 35.7714 36.1983 35.9849 35.9849L35.6313 35.6313L35.9849 35.9849C36.1983 35.7714 36.3677 35.518 36.4832 35.2391C36.5987 34.9601 36.6582 34.6612 36.6582 34.3593C36.6582 34.0574 36.5987 33.7585 36.4832 33.4796C36.3677 33.2006 36.1983 32.9472 35.9849 32.7337L35.9848 32.7337L26.8272 23.5796L35.9848 14.4255L35.9849 14.4254C36.1983 14.2119 36.3677 13.9585 36.4832 13.6796C36.5987 13.4007 36.6582 13.1017 36.6582 12.7998C36.6582 12.4979 36.5987 12.199 36.4832 11.9201C36.3677 11.6412 36.1983 11.3877 35.9849 11.1743C35.7714 10.9608 35.518 10.7915 35.2391 10.6759C34.9601 10.5604 34.6612 10.5009 34.3593 10.5009C34.0574 10.5009 33.7585 10.5604 33.4796 10.6759C33.2006 10.7915 32.9472 10.9608 32.7337 11.1743L32.7337 11.1743L23.5796 20.3319L14.4258 11.1747C14.4258 11.1746 14.4257 11.1745 14.4256 11.1744C14.2123 10.9607 13.959 10.7911 13.6801 10.6754L13.4926 11.1271L13.6801 10.6754C13.401 10.5596 13.1019 10.5 12.7998 10.5C12.4978 10.5 12.1986 10.5596 11.9196 10.6754C11.6406 10.7912 11.3872 10.9608 11.1738 11.1747L11.5278 11.5278L11.1747 11.1738C10.9608 11.3872 10.7912 11.6406 10.6754 11.9196C10.5596 12.1986 10.5 12.4978 10.5 12.7998C10.5 13.1019 10.5596 13.401 10.6754 13.6801L11.1271 13.4926L10.6754 13.6801C10.7911 13.959 10.9607 14.2123 11.1744 14.4256C11.1745 14.4257 11.1746 14.4258 11.1747 14.4258L20.3319 23.5796Z",
    stroke: "#73716D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4009_14330",
    x: 0,
    y: 0,
    width: 47.1582,
    height: 47.1582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.945098 0 0 0 0 0.447059 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4009_14330"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4009_14330",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhiteIcon);
export default __webpack_public_path__ + "static/media/CloseWhiteIcon.73c0f78aac504b381ef270694574e7c9.svg";
export { ForwardRef as ReactComponent };